export default "__VITE_PUBLIC_ASSET__22ff9afc__"